import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import 'custom-event-polyfill';
/**
 * Setter .value= is not working as we wanted because React library overrides
 * input value setter but we can call the function directly on the input as
 * context.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js
 */

export var triggerEvent = function triggerEvent(ref, type, value) {
  var eventInit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    bubbles: true
  };

  var nativeInputValueSetter = _Object$getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

  nativeInputValueSetter.call(ref, value);
  var event = new CustomEvent(type, eventInit);
  ref.dispatchEvent(event);
};